import { useContext } from 'react'

import AuthContext from '@contexts/Auth/AuthContext'

import { ENG_AND_PRODUCT_EMAILS } from '../constants/emailsList'

interface UseEmailPermissionProps {
  allowedEmails?: string[]
}

export const useEmailPermission = ({
  allowedEmails = ENG_AND_PRODUCT_EMAILS,
}: UseEmailPermissionProps = {}) => {
  const auth = useContext(AuthContext)
  const user = auth.user

  return !!user?.email && allowedEmails.includes(user?.email)
}
